// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — Edge Popover for Deleting Relations
// ═══════════════════════════════════════════════════════════════

import { useEffect, useRef } from 'react';
import { useI18n } from '../../../../i18n';

interface EdgePopoverProps {
  x: number;
  y: number;
  onDelete: () => void;
  onCancel: () => void;
}

export function EdgePopover({ x, y, onDelete, onCancel }: EdgePopoverProps) {
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useI18n();

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as HTMLElement)) {
        onCancel();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onCancel]);

  return (
    <div
      ref={ref}
      style={{
        position: 'fixed',
        left: x - 80,
        top: y - 50,
        zIndex: 100,
        background: '#fff',
        borderRadius: 8,
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        padding: '8px 12px',
        display: 'flex',
        gap: 6,
        alignItems: 'center',
      }}
    >
      <button
        onClick={onDelete}
        style={{
          padding: '6px 12px',
          borderRadius: 6,
          border: 'none',
          background: '#DC2626',
          color: '#fff',
          cursor: 'pointer',
          fontSize: 11,
          fontWeight: 600,
          fontFamily: 'inherit',
        }}
      >
        {t.structure.deleteRelation}
      </button>
      <button
        onClick={onCancel}
        style={{
          padding: '6px 12px',
          borderRadius: 6,
          border: '1px solid #D1D5DB',
          background: '#fff',
          color: '#5A6171',
          cursor: 'pointer',
          fontSize: 11,
          fontFamily: 'inherit',
        }}
      >
        {t.common.cancelar}
      </button>
    </div>
  );
}
